import { useQuery, useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';
import gqlFetcher from '../gqlFetcher';
const noop = d => d;
export const useAuthedQuery = ({
  queryKey,
  ...rest
}) => useQuery({
  ...rest,
  queryKey: ['authed'].concat(queryKey)
});
export const useAuthedQueries = args => useQueries(useMemo(() => {
  const {
    queries,
    ...rest
  } = args;
  return {
    ...rest,
    queries: queries.map(({
      queryKey,
      ...rest
    }) => ({
      ...rest,
      queryKey: ['authed'].concat(queryKey)
    }))
  };
}, [args]));
export const useGqlQuery = (query, vars, {
  transformer = noop,
  ...options
}) => useAuthedQuery({
  ...options,
  queryFn: () => gqlFetcher({
    document: query,
    variables: vars
  }).then(transformer)
});
export const useGqlQueries = (queries, fetcher = gqlFetcher) => useQueries({
  queries: queries.map(([query, vars, {
    queryKey,
    transformer = noop,
    ...options
  }]) => ({
    ...options,
    queryKey: ['authed'].concat(queryKey),
    queryFn: () => fetcher({
      document: query,
      variables: vars
    }).then(transformer)
  }))
});
export const useUnauthedGqlQuery = (query, vars, {
  transformer = noop,
  ...options
}) => useQuery({
  ...options,
  queryFn: () => gqlFetcher({
    document: query,
    variables: vars
  }).then(transformer)
});